<div class="top-level-structure">
  <router-outlet></router-outlet>
</div>